<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <div class="carDisLeft">
              <div class="dirTop">
                <el-scrollbar>
                  <tree
                    :isSearch="isSearch"
                    @initFun="initQuery"
                    @nodeClick="nodeClick"
                  ></tree>
                </el-scrollbar>
              </div>
              <div class="dirBottom">
                <el-input
                  style="width: 96%"
                  class="inputStyle"
                  @keyup.enter.native="onkeyUp"
                  v-model="carId"
                  size="small"
                  :placeholder="$t('common.searchTip')"
                ></el-input>
                <i-table
                  :list="list"
                  :height="height"
                  ref="carTable"
                  :options="option"
                  :columns="columns"
                  :operates="operates"
                  @rowClick="rowClick"
                ></i-table>
                <IPagination ref="page" @PageFun="changeSize"></IPagination>
              </div>
            </div>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="carDisRight">
        <div class="rightSearch">
          <el-date-picker
            v-model="timeValue"
            type="datetimerange"
            :range-separator="$t('common.to')"
            :start-placeholder="$t('common.starDate')"
            :end-placeholder="$t('common.endDate')"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <el-button
            size="mini"
            type="primary"
            @click="onSearch"
            >{{$t('common.btn.search')}}</el-button
          >
        </div>
        <div v-loading="mapLoading" class="carBaidu">
          <div
            id="allmap1"
            ref="allmap1"
            style="width: 100%; height: 100%"
          ></div>
          <div class="mapBtn" style="z-index: 111111">
            <el-row class="mapRow">
              <el-col :span="13">
                <el-slider
                  :min="0"
                  style="margin: 5px 5px 0 0"
                  @change="changeSlider"
                  v-model="carSpeed"
                  :step="25"
                  :marks="marks"
                  show-stops
                  :show-tooltip="false"
                ></el-slider>
              </el-col>
              <el-col style="line-height: 50px" :span="11">
                <el-button size="small" @click="run" type="primary"
                  >{{$t('VehicleManagement.btn.startPlayBack')}}</el-button
                >
                <el-button
                  size="small"
                  v-if="!btnStatus"
                  @click="Continue"
                  type="success"
                  >{{$t('VehicleManagement.btn.continuePlayBack')}}</el-button
                >
                <el-button
                  size="small"
                  v-if="btnStatus"
                  @click="pause"
                  type="success"
                  >{{$t('VehicleManagement.btn.stopPlayBack')}}</el-button
                >
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleTrajectory from "./VehicleTrajectory.js";
export default VehicleTrajectory;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
